function switchForSale(){
    $('#basic-search-form .input-group.to-rent').hide();
    $('#basic-search-form .input-group.for-sale').show();
    $('.search-container .private-sale-homes').removeClass('invisible');
    $('.advanced-search-rent-link').hide();
    $('.advanced-search-buy-link').show();
    $('#basic-search-form').attr("action", "/for-sale/property");
    $("#min-monthly-rent").prop('disabled', true);
    $("#max-monthly-rent").prop('disabled', true);
    $("#max-price").prop('disabled', false);
    $("#min-price").prop('disabled', false);
}

function switchToRent() {
    $('#basic-search-form .input-group.for-sale').hide();
    $('#basic-search-form .input-group.to-rent').show();
    $('.search-container .private-sale-homes').addClass('invisible');
    $('.advanced-search-buy-link').hide();
    $('.advanced-search-rent-link').show();
    $('#basic-search-form').attr("action", "/to-rent/property");
    $("#max-price").prop('disabled', true);
    $("#min-price").prop('disabled', true);
    $("#min-monthly-rent").prop('disabled', false);
    $("#max-monthly-rent").prop('disabled', false);
}
$( document ).ready(function() {
    if (document.getElementById('basic-search-form')){
        var selectedCategory = $('.category-selector').val();

        if( selectedCategory == 1 ){
            switchForSale();
        }
        else if( selectedCategory == 2 ){
            switchToRent();
        }

        $('.category-selector').change(function(event) {
            event.preventDefault();
            var self = this;
            $('.category-selector').prop("checked", false);
            $(this).prop("checked", true);
            $.uniform.update();
            if( $(this).val() == 1 ){
                switchForSale();
            }
            else if( $(this).val() == 2 ){
                switchToRent();
            }
        });

        $( "#advanced-button" ).click(function(event) {
            event.preventDefault();
            $("#show-advanced-form").val(1);
            $('#basic-search-form').submit();
        });
    }

    if (document.getElementById('min-price') && document.getElementById('max-price') ){
        $('#min-price, #max-price').change(function(event) {
            var selectedMinValue = $('#min-price').val();
            var selectedMaxValue = $('#max-price').val();
            if( $.isNumeric(selectedMinValue) && $.isNumeric(selectedMaxValue) ){
                if( parseInt(selectedMinValue) > parseInt(selectedMaxValue) )
                {
                    if( $(this).attr('id') == 'min-price' ){
                        $("#max-price").val(selectedMinValue);
                        $("#min-price").val(selectedMaxValue);
                    }
                    else if( $(this).attr('id') == 'max-price' ){
                        $("#min-price").val(selectedMaxValue);
                        $("#max-price").val(selectedMinValue);
                    }
                }
            }
            $.uniform.update($('#min-price'));
            $.uniform.update($('#max-price'));
            window.makeDropdownSelectedBlack($('#min-price'));
            window.makeDropdownSelectedBlack($('#max-price'));
        })
    }

    if (document.getElementById('min-monthly-rent') && document.getElementById('max-monthly-rent') ){
        $('#min-monthly-rent, #max-monthly-rent').change(function(event) {
            var selectedMinValue = $('#min-monthly-rent').val();
            var selectedMaxValue = $('#max-monthly-rent').val();
            if( $.isNumeric(selectedMinValue) && $.isNumeric(selectedMaxValue) ){
                if( parseInt(selectedMinValue) > parseInt(selectedMaxValue) )
                {
                    if( $(this).attr('id') == 'min-monthly-rent' ){
                        $("#max-monthly-rent").val(selectedMinValue);
                        $("#min-monthly-rent").val(selectedMaxValue);
                    }
                    else if( $(this).attr('id') == 'max-monthly-rent' ){
                        $("#min-monthly-rent").val(selectedMaxValue);
                        $("#max-monthly-rent").val(selectedMinValue);
                    }
                }
            }
            $.uniform.update($('#min-monthly-rent'));
            $.uniform.update($('#max-monthly-rent'));
            window.makeDropdownSelectedBlack($('#min-monthly-rent'));
            window.makeDropdownSelectedBlack($('#max-monthly-rent'));
        })
    }

});